module.exports = __webpack_public_path__ + "img/trolley.26768527.svg";